/** @jsxImportSource @emotion/react */
import { AiFillCar } from "react-icons/ai";
import { GiFactory } from "react-icons/gi";
import "twin.macro";

export const WrenchIcon = (props) => {
  return (
    <svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.75 6.75a4.5 4.5 0 0 1-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 1 1-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 0 1 6.336-4.486l-3.276 3.276a3.004 3.004 0 0 0 2.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852Z"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.867 19.125h.008v.008h-.008v-.008Z" />
    </svg>
  );
};

export const TagIcon = (props) => {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M5.25 2.25a3 3 0 0 0-3 3v4.318a3 3 0 0 0 .879 2.121l9.58 9.581c.92.92 2.39 1.186 3.548.428a18.849 18.849 0 0 0 5.441-5.44c.758-1.16.492-2.629-.428-3.548l-9.58-9.581a3 3 0 0 0-2.122-.879H5.25ZM6.375 7.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const ChevronLeftSolidIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const ChevronRightSolidIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const SearchSolidIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const BellOutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
      />
    </svg>
  );
};

export const MenuAlt2OutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 6h16M4 12h16M4 18h7"
      />
    </svg>
  );
};

export const HomeOutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
      />
    </svg>
  );
};

export const XOutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
};

export const ClipboardCheckOutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
      />
    </svg>
  );
};

export const CheckCircleSolidIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const FlagOutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9"
      />
    </svg>
  );
};

export const BookmarkOutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
      />
    </svg>
  );
};

export const LocationMarkerOutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
};

export const UsersOutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
      />
    </svg>
  );
};

export const CalendarOutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  );
};

export const AdjustmentsOutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
      />
    </svg>
  );
};

/** Not part of Heroicons */
export const UploadFileIcon = (props) => {
  return (
    <svg stroke="currentColor" fill="none" viewBox="0 0 48 48" {...props}>
      <path
        d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowNarrowLeftIcon = (props) => {
  return (
    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M7 16l-4-4m0 0l4-4m-4 4h18"
      />
    </svg>
  );
};

export const ArrowNarrowRightIcon = (props) => {
  return (
    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17 8l4 4m0 0l-4 4m4-4H3"
      />
    </svg>
  );
};

export const CloudXOutlineIcon = (props) => {
  return (
    <svg fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-10 5 5 0 10-9.8 2.1A4 4 0 003 15v0zM10 16l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"
      />
    </svg>
  );
};

export const CloudCheckOutlineIcon = (props) => {
  return (
    <svg fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-10 5 5 0 10-9.8 2.1A4 4 0 003 15v0z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8.9 13.9l1.5 1.5 3.7-3.8"
      />
    </svg>
  );
};

export const CloudExclamationOutlineIcon = (props) => {
  return (
    <svg fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-10 5 5 0 10-9.8 2.1A4 4 0 003 15v0zM12 10v3m0 3h0"
      />
    </svg>
  );
};

export const DesktopComputerOutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
    </svg>
  );
};

export const DocumentOutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
      />
    </svg>
  );
};

export const ExclamationCircleSolidIcon = (props) => {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const CreditCardOutlineIcon = (props) => {
  return (
    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
      />
    </svg>
  );
};

export const TagOutlineIcon = (props) => {
  return (
    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
      />
    </svg>
  );
};

export const ChevronDownSolidIcon = (props) => {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const CalendarSolidIcon = (props) => {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const XSolidIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const DocumentDownloadSolidIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const ChartBarOutlineIcon = (props) => {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
      />
    </svg>
  );
};

export const SmallArrowUpSolidIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const SmallArrowDownSolidIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const RimOutlineIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M18.7501 11.1849C19.2664 10.989 19.5261 10.4115 19.3302 9.89516C19.1342 9.37881 18.5567 9.1191 18.0404 9.31507L18.7501 11.1849ZM12.0113 16.6464C11.7581 17.1372 11.9506 17.7404 12.4414 17.9937C12.9322 18.2469 13.5354 18.0544 13.7886 17.5636L12.0113 16.6464ZM12.2978 9.31068C11.779 9.12122 11.2049 9.38817 11.0154 9.90694C10.8259 10.4257 11.0929 10.9998 11.6117 11.1893L12.2978 9.31068ZM16.5366 17.5121C16.7614 18.0165 17.3526 18.2432 17.857 18.0184C18.3615 17.7936 18.5882 17.2024 18.3634 16.698L16.5366 17.5121ZM16.9134 13.4443C16.6886 12.9398 16.0974 12.7131 15.593 12.9379C15.0885 13.1627 14.8618 13.7539 15.0866 14.2584L16.9134 13.4443ZM15.5631 14.0646C15.8069 13.569 15.6027 12.9697 15.1071 12.726C14.6115 12.4823 14.0121 12.6865 13.7684 13.1821L15.5631 14.0646ZM20 12C20 14.6258 19.4125 16.9535 18.5129 18.5891C17.5935 20.2608 16.4856 21 15.5 21V23C17.552 23 19.1941 21.5006 20.2653 19.553C21.3563 17.5694 22 14.8971 22 12H20ZM15.5 3C16.4856 3 17.5935 3.73919 18.5129 5.41085C19.4125 7.04651 20 9.37422 20 12H22C22 9.10293 21.3563 6.43064 20.2653 4.44701C19.1941 2.49939 17.552 1 15.5 1V3ZM15.5 1H8.5V3H15.5V1ZM8.5 21C7.51444 21 6.40654 20.2608 5.48713 18.5891C4.58752 16.9535 4 14.6258 4 12H2C2 14.8971 2.6437 17.5694 3.7347 19.553C4.80589 21.5006 6.44799 23 8.5 23V21ZM4 12C4 9.37422 4.58752 7.04651 5.48713 5.41085C6.40654 3.73919 7.51444 3 8.5 3V1C6.44799 1 4.80589 2.49939 3.7347 4.44701C2.6437 6.43064 2 9.10293 2 12H4ZM8.5 23H15.5V21H8.5V23ZM17.5 12C17.5 13.8183 17.1478 15.4155 16.6228 16.5207C16.062 17.7013 15.4832 18 15.175 18V20C16.7031 20 17.7868 18.7317 18.4294 17.3788C19.1078 15.9505 19.5 14.0477 19.5 12H17.5ZM15.175 18C14.8667 18 14.2879 17.7013 13.7271 16.5207C13.2021 15.4155 12.85 13.8183 12.85 12H10.85C10.85 14.0477 11.2421 15.9505 11.9206 17.3788C12.5632 18.7317 13.6469 20 15.175 20V18ZM12.85 12C12.85 10.1817 13.2021 8.58454 13.7271 7.47931C14.2879 6.2987 14.8667 6 15.175 6V4C13.6469 4 12.5632 5.26831 11.9206 6.6212C11.2421 8.04946 10.85 9.9523 10.85 12H12.85ZM15.175 6C15.4832 6 16.062 6.2987 16.6228 7.47931C17.1478 8.58454 17.5 10.1817 17.5 12H19.5C19.5 9.9523 19.1078 8.04946 18.4294 6.6212C17.7868 5.26831 16.7031 4 15.175 4V6ZM11.6117 11.1893L14.0075 12.0643L14.6936 10.1857L12.2978 9.31068L11.6117 11.1893ZM14.175 5C14.175 5.39608 14.1939 6.65702 14.2126 7.80552C14.222 8.38273 14.2314 8.93575 14.2384 9.34444C14.2419 9.54879 14.2449 9.71709 14.2469 9.83431C14.248 9.89292 14.2488 9.93876 14.2493 9.96995C14.2496 9.98555 14.2498 9.99749 14.2499 10.0055C14.25 10.0096 14.2501 10.0126 14.2501 10.0146C14.2501 10.0157 14.2501 10.0164 14.2501 10.017C14.2501 10.0172 14.2502 10.0174 14.2502 10.0175C14.2502 10.0176 14.2502 10.0177 14.2502 10.0177C14.2502 10.0177 14.2502 10.0177 15.25 10C16.2498 9.98226 16.2498 9.98225 16.2498 9.98222C16.2498 9.98218 16.2498 9.98214 16.2498 9.98207C16.2498 9.98195 16.2498 9.98176 16.2498 9.9815C16.2498 9.98099 16.2498 9.98023 16.2498 9.97922C16.2498 9.97719 16.2497 9.97416 16.2496 9.97016C16.2495 9.96215 16.2493 9.95025 16.249 9.93469C16.2485 9.90357 16.2476 9.85781 16.2466 9.79928C16.2446 9.68223 16.2416 9.51414 16.2381 9.31001C16.2311 8.90172 16.2217 8.34938 16.2124 7.77301C16.1935 6.61435 16.175 5.37529 16.175 5H14.175ZM18.3952 10.25C18.0404 9.31507 18.0404 9.31508 18.0403 9.31509C18.0403 9.3151 18.0403 9.31511 18.0402 9.31512C18.0402 9.31515 18.0401 9.31518 18.04 9.31522C18.0398 9.31531 18.0395 9.31542 18.0391 9.31557C18.0383 9.31586 18.0372 9.31628 18.0358 9.31683C18.0329 9.31792 18.0287 9.31951 18.0233 9.32159C18.0124 9.32573 17.9965 9.33179 17.9761 9.33958C17.9354 9.35517 17.8766 9.37772 17.8039 9.40581C17.6585 9.46194 17.4568 9.54042 17.2314 9.62982C16.7871 9.80609 16.2282 10.0336 15.8308 10.2171L16.6692 12.0329C17.0119 11.8747 17.5257 11.6647 17.9689 11.4889C18.1873 11.4023 18.3831 11.3261 18.5244 11.2715C18.5949 11.2443 18.6517 11.2225 18.6907 11.2076C18.7102 11.2001 18.7252 11.1944 18.7353 11.1906C18.7403 11.1886 18.7441 11.1872 18.7466 11.1863C18.7478 11.1858 18.7487 11.1854 18.7493 11.1852C18.7496 11.1851 18.7498 11.185 18.75 11.185C18.75 11.1849 18.7501 11.1849 18.7501 11.1849C18.7501 11.1849 18.7501 11.1849 18.7501 11.1849C18.7501 11.1849 18.7501 11.1849 18.3952 10.25ZM17.45 17.105C18.3634 16.698 18.3634 16.698 18.3634 16.6979C18.3634 16.6979 18.3634 16.6979 18.3633 16.6979C18.3632 16.6975 18.3634 16.698 18.3632 16.6976C18.3631 16.6974 18.3629 16.697 18.3627 16.6965C18.3623 16.6957 18.3616 16.6941 18.3608 16.6922C18.3591 16.6885 18.3566 16.6828 18.3533 16.6754C18.3467 16.6606 18.3369 16.6386 18.3243 16.6103C18.299 16.5536 18.2623 16.4711 18.2165 16.3683C18.1248 16.1625 17.9966 15.8749 17.8507 15.5476C17.559 14.893 17.1965 14.0796 16.9134 13.4443L15.0866 14.2584C15.3697 14.8937 15.7322 15.7071 16.0239 16.3617C16.1698 16.689 16.2979 16.9766 16.3896 17.1824C16.4355 17.2853 16.4722 17.3677 16.4975 17.4244C16.5101 17.4527 16.5199 17.4747 16.5265 17.4895C16.5298 17.4969 16.5323 17.5025 16.534 17.5063C16.5349 17.5083 16.5355 17.5096 16.5359 17.5106C16.5362 17.5111 16.5363 17.5114 16.5364 17.5117C16.5364 17.5118 16.5365 17.5118 16.5365 17.5119C16.5365 17.5119 16.5365 17.5119 16.5365 17.512C16.5365 17.512 16.5366 17.512 16.5366 17.512C16.5366 17.5121 16.5366 17.5121 17.45 17.105ZM12.9 17.105C13.7886 17.5636 13.7886 17.5636 13.7887 17.5636C13.7887 17.5635 13.7887 17.5635 13.7887 17.5635C13.7887 17.5634 13.7888 17.5633 13.7889 17.5632C13.789 17.5629 13.7892 17.5625 13.7895 17.5619C13.7901 17.5608 13.7909 17.5592 13.792 17.5571C13.7942 17.5528 13.7975 17.5464 13.8018 17.5381C13.8103 17.5215 13.823 17.497 13.8392 17.4654C13.8718 17.4023 13.9189 17.3106 13.9774 17.1968C14.0945 16.9691 14.257 16.6522 14.4392 16.2954C14.8027 15.5835 15.2471 14.7073 15.5631 14.0646L13.7684 13.1821C13.4596 13.8101 13.0211 14.6747 12.6579 15.3859C12.4768 15.7408 12.315 16.0561 12.1986 16.2826C12.1404 16.3959 12.0935 16.4869 12.0612 16.5496C12.0451 16.581 12.0326 16.6052 12.0241 16.6216C12.0199 16.6298 12.0167 16.6361 12.0145 16.6402C12.0135 16.6423 12.0126 16.6439 12.0121 16.6449C12.0118 16.6454 12.0116 16.6458 12.0115 16.6461C12.0114 16.6462 12.0114 16.6463 12.0114 16.6464C12.0113 16.6464 12.0113 16.6464 12.0113 16.6464C12.0113 16.6464 12.0113 16.6464 12.9 17.105ZM15.5 12C15.5 12.3479 15.388 12.6544 15.2524 12.8561C15.1848 12.9565 15.1268 13.0081 15.1008 13.0264C15.0691 13.0488 15.1205 13 15.25 13V15C16.0267 15 16.6014 14.4338 16.9118 13.9724C17.2632 13.4501 17.5 12.7567 17.5 12H15.5ZM15.25 13C15.3795 13 15.4309 13.0488 15.3992 13.0264C15.3732 13.0081 15.3152 12.9565 15.2476 12.8561C15.112 12.6544 15 12.3479 15 12H13C13 12.7567 13.2368 13.4501 13.5882 13.9724C13.8986 14.4338 14.4733 15 15.25 15V13ZM15 12C15 11.6521 15.112 11.3456 15.2476 11.1439C15.3152 11.0435 15.3732 10.9919 15.3992 10.9736C15.4309 10.9512 15.3795 11 15.25 11V9C14.4733 9 13.8986 9.56617 13.5882 10.0276C13.2368 10.5499 13 11.2433 13 12H15ZM15.25 11C15.1205 11 15.0691 10.9512 15.1008 10.9736C15.1268 10.9919 15.1848 11.0435 15.2524 11.1439C15.388 11.3456 15.5 11.6521 15.5 12H17.5C17.5 11.2433 17.2632 10.5499 16.9118 10.0276C16.6014 9.56617 16.0267 9 15.25 9V11Z" />
    </svg>
  );
};

export const TireOutlineIcon = (props) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...props}>
      <path
        d="M16 22C18.7614 22 21 17.5228 21 12C21 6.47715 18.7614 2 16 2H8C5.23858 2 3 6.47715 3 12C3 17.5228 5.23858 22 8 22H16Z"
        strokeWidth={2}
      />
      <path
        d="M18.5 12C18.5 15.3137 17.6569 18 16 18C14.3431 18 13 15.3137 13 12C13 8.68629 14.3431 6 16 6C17.6569 6 18.5 8.68629 18.5 12Z"
        strokeWidth={2}
      />
    </svg>
  );
};

export const DocumentReportOutlineIcon = (props) => {
  return (
    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
      />
    </svg>
  );
};

export const ExternalLinkSolidIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
      <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
    </svg>
  );
};

export const ArrowsExpandOutlineIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
      />
    </svg>
  );
};

export const HashtagOutlineIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"
      />
    </svg>
  );
};

export const ReplySolidIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        d="M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const ArchiveSolidIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4 3a2 2 0 100 4h12a2 2 0 100-4H4z" />
      <path
        fillRule="evenodd"
        d="M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const LockClosedIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export const LockOpenIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10 2a5 5 0 00-5 5v2a2 2 0 00-2 2v5a2 2 0 002 2h10a2 2 0 002-2v-5a2 2 0 00-2-2H7V7a3 3 0 015.905-.75 1 1 0 001.937-.5A5.002 5.002 0 0010 2z"></path>
    </svg>
  );
};

export const DuplicateSolidIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z"></path>
      <path d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z"></path>
    </svg>
  );
};

export const CameraSolidIcon = (props) => {
  return (
    <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        d="M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const SettingsOutlineIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-6 w-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
};

export const BarCodeIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 24 24"
      {...props}
      fill="currentColor"
    >
      <path d="M22 22h-20c-1.104 0-2-.896-2-2v-16c0-1.104.896-2 2-2h20c1.104 0 2 .896 2 2v16c0 1.104-.896 2-2 2zm0-18h-20v16h20v-16zm-2 14h-1v-12h1v12zm-5 0h-1v-12h1v12zm-2 0h-1v-12h1v12zm-2 0h-2v-12h2v12zm-3 0h-1v-12h1v12zm10 0h-2v-12h2v12zm-12 0h-2v-12h2v12z" />
    </svg>
  );
};

export const FactoryIcon = (props) => {
  return <GiFactory {...props} />;
};

export const VehiculeIcon = (props) => {
  return <AiFillCar {...props} />;
};

export const TriangleIcon = (props) => {
  return (
    <svg viewBox="0 0 84 74" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M37.6699 4.5C39.5944 1.16667 44.4056 1.16667 46.3301 4.5L80.9711 64.5C82.8956 67.8333 80.49 72 76.641 72H7.35899C3.50998 72 1.10436 67.8333 3.02886 64.5L37.6699 4.5Z"
        stroke="currentColor"
        strokeWidth="5"
      />
    </svg>
  );
};

export const Loader = ({ ...props }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    tw="animate-spin"
    {...props}
  >
    <path
      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      fill="currentFill"
    />
    <path
      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      fill="currentColor"
    />
  </svg>
);

export const MegaphoneIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="2"
    stroke="currentColor"
    className="h-6 w-6"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46"
    />
  </svg>
);

export const LineChart = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    // class="lucide lucide-chart-line-icon lucide-chart-line"
    {...props}
  >
    <path d="M3 3v16a2 2 0 0 0 2 2h16" />
    <path d="m19 9-5 5-4-4-3 3" />
  </svg>
);

export const BarChart = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    // class="lucide lucide-chart-column-icon lucide-chart-column"
    {...props}
  >
    <path d="M3 3v16a2 2 0 0 0 2 2h16" />
    <path d="M18 17V9" />
    <path d="M13 17V5" />
    <path d="M8 17v-3" />
  </svg>
);

export const NoChart = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    // class="lucide lucide-circle-off-icon lucide-circle-off"
    {...props}
  >
    <path d="m2 2 20 20" />
    <path d="M8.35 2.69A10 10 0 0 1 21.3 15.65" />
    <path d="M19.08 19.08A10 10 0 1 1 4.92 4.92" />
  </svg>
);
